import React from 'react'
import cn from 'classnames'

import styles from './MarqueeCards.module.css'

type MarqueeRowProps = {
  elements: JSX.Element[]
  ariaHidden?: boolean
}

const MarqueeRow = ({
  elements,
  ariaHidden = false,
}: MarqueeRowProps): JSX.Element => (
  <div className={cn(styles.marqueeRow)} aria-hidden={ariaHidden}>
    {elements}
  </div>
)

type MarqueeCardsProps = {
  elements: JSX.Element[]
  slower?: boolean
}

const MarqueeCards = ({
  elements,
  slower = false,
}: MarqueeCardsProps): JSX.Element => (
  <div className={cn(styles.marquee, { [styles.marqueeSlower]: slower })}>
    <MarqueeRow elements={elements} />
    <MarqueeRow elements={elements} ariaHidden />
  </div>
)

export default MarqueeCards
